import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Text from 'components/ui/text';
import View from 'components/ui/view';
import Card from 'components/ui/card';
import LoadingSpinner from 'components/ui/loadingSpinner';
import { withConjunction } from 'shared/utils';
import {
  isCompletedOrder,
  isActiveOrder,
  isCanceledOrder,
  isFailedOrder,
  isTotalLineItem
} from 'shared/models/order';
import { loadOrderHistory } from './actions';

let OrderHistory = class OrderHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1 };
  }

  componentDidMount() {
    const orders = this.props.orders || [];
    if (!orders.length && !this.props.loading) {
      this.props.loadOrderHistory();
    }
  }

  loadMore() {
    const page = this.state.page + 1;
    this.props.loadOrderHistory({ page }).then(() => {
      this.setState(state => ({ ...state, page: state.page + 1 }));
    });
  }

  render() {
    const orders = this.props.orders || [];
    const canLoadMore = orders.length < this.props.count;

    return (
      <View padding="md" className="order-history banner-padding">
        <Text title tag="h2" weight="med" size="md">
          Your Orders
        </Text>
        <View margin="sm">
          <Card block>
            {this.props.loading &&
              orders.length === 0 && (
                <div
                  style={{
                    minHeight: '300px',
                    position: 'relative',
                    marginTop: '75px'
                  }}
                >
                  <LoadingSpinner black />
                </div>
              )}

            {orders.map(order => (
              <OrderHistoryRow key={order._id} order={order} />
            ))}
          </Card>
        </View>
        {canLoadMore && (
          <button
            disabled={this.props.loading}
            className="btn--full-width btn--tertiary"
            onClick={() => this.loadMore()}
          >
            Load More Orders
          </button>
        )}
      </View>
    );
  }
};

OrderHistory = connect(
  state => ({
    orders: state.orderHistory.orders,
    loading: state.orderHistory.ordersLoading,
    count: state.orderHistory.count
  }),
  { loadOrderHistory }
)(OrderHistory);

function OrderHistoryRow({ order }) {
  const totalLineItem = _.find(order.line_items, isTotalLineItem) || {};
  const total = totalLineItem.display;
  const products = order.products || [];
  const productNames = withConjunction(products.map(p => p.title));
  const canRateAndTip =
    !order.shipping &&
    isCompletedOrder(order) &&
    typeof order.order_rating === 'undefined' &&
    typeof order.order_tip === 'undefined';

  return (
    <View padding="sm" className="order-history-row">
      <div className="row middle-xs">
        <div className="col-xs-8 col-sm-9">
          <View margin="xxs">
            <Text
              secondary
              title
              size="sm"
              weight="med"
              className="text-overflow hidden-sm"
            >
              {moment(order.order_date).format('MMMM D, YYYY')}
            </Text>
            <Text
              secondary
              title
              size="sm"
              weight="med"
              className="text-overflow visible-sm-block"
            >
              {moment(order.order_date).format('MMMM D, YYYY h:mm A')}
            </Text>
          </View>
          <div className="text-overflow">{productNames}</div>
        </div>
        <div className="col-xs-4 col-sm-3 text-right">
          {canRateAndTip ? (
            <a href={`/tip/${order._id}`}>
              <View margin="xxs">
                <Text display success weight="med" size="xs">
                  Rate & Tip
                </Text>
              </View>
            </a>
          ) : isActiveOrder(order) ? (
            <a href={`/tracking/${order._id}`}>
              <View margin="xxs">
                <Text display success weight="med" size="xs">
                  Track Order
                </Text>
              </View>
            </a>
          ) : (
            <Link to={`/orders/${order._id}`}>
              <View margin="xxs">
                {isFailedOrder(order) || isCanceledOrder(order) ? (
                  <Text display error weight="med" size="xs">
                    Canceled
                  </Text>
                ) : (
                  <Text display weight="med" size="xs">
                    {total}
                  </Text>
                )}
              </View>
              <Text display secondary size="xs">
                View Details
              </Text>
            </Link>
          )}
        </div>
      </div>
    </View>
  );
}

export default OrderHistory;



// WEBPACK FOOTER //
// ./shared/components/orderHistory/index.js